import { errorHandler } from "./error.service";
import { http, URL } from "./http.service";

export const createNote = async (businessId, data) => {
  try {
    let resp = await http.post(`${URL}/notes/${businessId}/create`, data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const getDebitNotes = async (businessId, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(`${URL}/notes/${businessId}/get-all-notes/debit?${queryString}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const getCreditNotes = async (businessId, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(
      `${URL}/notes/${businessId}/get-all-notes/credit?${queryString}`
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const updatenotes = async (businessId, noteNumber, data) => {
  try {
    let resp = await http.put(`${URL}/notes/${businessId}/${noteNumber}`, data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const deletenotes = async (businessId, noteNumber) => {
  try {
    let resp = await http.delete(`${URL}/notes/${businessId}/${noteNumber}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const getNoteDocumentDownloadUrl = async (businessId, noteNumber) => {
  try {
    let resp = await http.get(
      `${URL}/notes/${businessId}/${noteNumber}/download-document`
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
